'use strict';

import Loader from '../loader/loader';
import '../../_assets/abbott/js/_modernizr';
import { isFieldEmpty, isValidEmail, displayErrors } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';
import Handlebars from 'handlebars';
// import ClassicEditor from 'ckeditor';

export default class HensContent {
    constructor() {
        let $body = $('body'),
            $newContentDropdown = $('.hens-content-new__dropdown'),
            $hensContentId = $('#HensContentId'),
            $title = $('#NewContentTitle'),
            $description = $('#NewContentShortDescription'),
            $content = $('#NewContent'),
            $status = $('#NewContentStatus'),
            $type = $('#NewContentType'),
            $image = $('#NewContentImage'),
            $imageHolder = $('.content-image'),
            $templateItem = $('#tmpContentItem'),
            $contentItems = $('#HensContentItems'),
            $contentItemsHolder = $('.content-items-holder'),
            _currentIdx = -1,
            _maxItems = 8,
            _contentItems = [],
            loader = new Loader(),
            _isInvalid = [],
            dataParams = {},
            contentEditor = null,
            $typeFilter = $('#FilterByType li');

            
        // This plugin brings customization to the downcast pipeline of the editor.
        function AddFontSizeToListItems( editor ) {
            console.log("Called plugin");
            // Both the data and the editing pipelines are affected by this conversion.
            editor.conversion.for( 'downcast' ).add( dispatcher => {
                // Links are represented in the model as a "linkHref" attribute.
                // Use the "low" listener priority to apply the changes after the link feature.
                dispatcher.on( 'attribute:fontSize', ( evt, data, conversionApi ) => {
                    if(data.item == null) return;
                    const viewWriter = conversionApi.writer;
                    const viewSelection = viewWriter.document.selection;

                    // Adding a new CSS class is done by wrapping all link ranges and selection
                    // in a new attribute element with the "target" attribute.
                    let attNewVal = data.attributeNewValue;
                    let attOldVal = data.attributeOldValue;
                    let itemParent = data.item.parent;
                    
                    if(itemParent != null && itemParent.name == "listItem") {
                        if(attNewVal != null) {
                            viewWriter.addClass( `text-${attNewVal}`, conversionApi.mapper.toViewElement( data.item.parent ) );
                        }

                        if(attOldVal != null){
                            viewWriter.removeClass( `text-${attOldVal}`, conversionApi.mapper.toViewElement( data.item.parent ) );
                        }
                    }
                }, { priority: 'low' } );
            } );
        }

        function initialiseEditor(content){
            //initialise ckeditor
            if(contentEditor == null){
                ClassicEditor
                .create($content.get(0), {
                    extraPlugins: [AddFontSizeToListItems]
                })
                .then( editor => {
                    contentEditor = editor;
                    contentEditor.setData($("<div></div>").html(content).text());
                    console.log( 'Editor was initialized', editor );
                } )
                .catch( error => {
                    console.error( error.stack );
                });
            } else {
                contentEditor.setData($("<div></div>").html(content).text());
            }
        }

        //if this is display view
        if($contentItems.length > 0 && $templateItem.length > 0){
            _contentItems = JSON.parse($contentItems.val());
            if(_contentItems.length > 0) {
                displayContentTiles();
            }
        }

        if(_contentItems.length == 0 && $contentItems.length > 0){
            $('.js-more-artcles').hide();
            $contentItemsHolder.append("<div class='col-12'><p>There are no articles available at this time. Please try again later.</p></div>");
        }

        function displayContentTiles() {
            _currentIdx++;
            let nextBatch = getIndexedItems(_contentItems, _currentIdx * _maxItems, _maxItems);
            let template = doT.template($templateItem.html());
            let contentHtml = template({items: nextBatch});
            $contentItemsHolder.append(contentHtml);
            
            if(((_currentIdx + 1) * _maxItems) >= _contentItems.length) {
                $('.js-more-artcles').hide();
            }
        }

        function getIndexedItems(items, start, stop) {
            let newItems = [];
            let currIdx = 0;
            for(let i = start; currIdx < stop && i < items.length; i++) {
                newItems.push(items[i]);
                if(i == items.length){
                    break;
                }
                currIdx++;
                if(currIdx == stop) {
                    break;
                }
            }
            return newItems;
        }

        function loadContent() {

            let typeFilter = $('#FilterByType .filter-dropdown--selected'),
                typeQuery = typeFilter.attr('data-value');
            
            loader.fadeIn();
            $.ajax({
                url: '/api/henscontent/getall/'+typeQuery,
                type: 'GET',
                // headers: { __RequestVerificationToken: $('#new-content-form').find('input[name=__RequestVerificationToken]').val() },
                contentType: false,
                processData: false,
                success: function (data) {
                    loader.fadeOut();
                    
                    let $rowItemTemplateSource = $('#tmpContentRow').html(),
                        $rowItemTemplate = Handlebars.compile($rowItemTemplateSource),
                        $tbl = $('#table-sort-content'),
                        html = [];
                    data.forEach(element => {
                        element.DateCreatedString = moment.utc(element.DateCreated).local().format("DD-MM-YYYY HH:mm");
                        let badgeStatus = "badge-warning";
                        switch (element.Status)
                        {
                            case "Published":
                                badgeStatus = "badge-success";
                                break;
                            case "Archived":
                                badgeStatus = "badge-secondary";
                                break;
                            default:
                                break;
                        }
                        element.StatusBadge = badgeStatus;
                        html.push($rowItemTemplate(element));
                    });
                    if($tbl.DataTable() != null) {
                        $tbl.DataTable().destroy();
                    }
                    $tbl.find('tbody').html(html.join(""));
                    $tbl.DataTable({
                        dom: '<"">frtip',
                        order: [[2, 'desc']],
                    });
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        }

        $typeFilter.on('click', function(e){
            e.preventDefault();
            loadContent();
        });

        $('.js-more-artcles').on('click', function(e){
            e.preventDefault();
            displayContentTiles();
        })

        $(document).on("click", ".js-edit-content", function(e){
            e.preventDefault();
            var dataId = $(this).data("id");

            loader.fadeIn();
            $.ajax({
                url: '/api/henscontent/get/'+dataId,
                type: 'GET',
                // headers: { __RequestVerificationToken: $('#new-content-form').find('input[name=__RequestVerificationToken]').val() },
                contentType: false,
                processData: false,
                success: function (data) {
                    loader.fadeOut();
                    $hensContentId.val(data.Id);
                    $title.val(data.Title);
                    $description.val(data.Description);
                    $status.val(data.Status);
                    $type.val(data.ContentType);
                    if(data.Image != "") {
                        $imageHolder.html(`<img src="${data.ImagePath}" />`)
                    }
                    $newContentDropdown.addClass("editting");
                    $newContentDropdown.removeClass("header-content");
                    if(data.UrlName == "patient-header" || data.UrlName == "dietitian-header") {
                        $newContentDropdown.addClass("header-content");
                    }
                    $newContentDropdown.slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false,
                        complete: function () {
                            $body.addClass('fixed');
                            initialiseEditor(data.Content);
                        }
                    });
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        });


        $('.js-add-new-content').on('click', function (e) {
            e.preventDefault();
            
            $newContentDropdown.removeClass("editting");
            $newContentDropdown.removeClass("header-content");
            $hensContentId.val("0");
            $title.val("");
            $description.val("");
            $status.val("Draft");
            $type.val("Patient");
            $image.val('');
            $newContentDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                    initialiseEditor("");
                }
            });
        });

        $('.js-create-new-content').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            _isInvalid = [];

            if (isFieldEmpty($title)) {
                $title
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($description)) {
                $description
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (contentEditor.getData() == "") {
                $content
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($status)) {
                $status
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($type)) {
                $type
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                loader.fadeIn();
                $(this).removeClass('error');
            }

            var data = new FormData();

            var files = $image.get(0).files;

            // Add the uploaded image content to the form data collection
            if (files.length > 0) {
                data.append("HensContentImage", files[0]);
            }

            data.append("Title",$title.val());
            data.append("Description", $description.val());
            data.append("Content", $(`<div></div>`).text(contentEditor.getData()).html());
            data.append("Status", $status.val());
            data.append("ContentType", $type.val());
            data.append("Id", $hensContentId.val());

            $.ajax({
                url: '/api/henscontent/update',
                type: 'POST',
                headers: { __RequestVerificationToken: $('#new-content-form').find('input[name=__RequestVerificationToken]').val() },
                contentType: false,
                processData: false,
                data: data,
                success: function (data) {
                    toaster('Content has been saved!');
                    let typeFilter = $('#FilterByType .filter-dropdown--selected'),
                        typeQuery = typeFilter.attr('data-value');
                    window.location.href = window.location.pathname + (typeQuery != null ? "?type="+typeQuery : "");
                   
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });

                    $('.js-collapse-form-modal').trigger('click');
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });

        });
    }
}
